// extracted by mini-css-extract-plugin
export default {"container":"ServicesSection_container__PVqQO","title":"ServicesSection_title__VIlnG","grid":"ServicesSection_grid__qK1pH","card":"ServicesSection_card__Ktk7J"};